import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import api from "../lib/api";
import { FadeUp } from "../components/Motion";
import PageMeta from "../components/PageMeta";

export default function Areas() {
  const [areas, setAreas] = useState([]);

  useEffect(() => {
    api.get("/service-areas").then((r) => setAreas(r.data || []));
  }, []);

  return (
    <div data-testid="areas-index-page" className="pt-32 pb-32">
      <PageMeta
        title="Service Areas — Edmonton & Region"
        description="Premium landscape construction and outdoor living across Edmonton, St. Albert, Sherwood Park, Beaumont, Leduc, Spruce Grove, and Fort Saskatchewan."
        path="/areas"
      />

      <section className="px-6 md:px-12 lg:px-16 mb-16">
        <FadeUp>
          <div className="overline text-[#8C1D30] mb-4">Service Areas</div>
          <h1 className="font-serif-display text-5xl md:text-7xl lg:text-8xl leading-none max-w-5xl">
            Edmonton & <span className="italic text-[#D8D6D0]">surrounding</span> region.
          </h1>
          <p className="text-[#D8D6D0]/60 mt-8 max-w-2xl text-lg">
            We design and build across Greater Edmonton. Tap a city to see local projects, timelines, and a direct line to a senior designer.
          </p>
        </FadeUp>
      </section>

      <section className="px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {areas.map((a, i) => (
            <FadeUp key={a.slug} delay={i * 0.05}>
              <Link
                to={`/areas/${a.slug}`}
                data-testid={`area-card-${a.slug}`}
                className="group block relative overflow-hidden border border-[#D8D6D0]/10 hover:border-[#D8D6D0]/30 transition-colors"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={a.image_url}
                    alt={a.name}
                    className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-7 flex items-end justify-between gap-4">
                  <div>
                    <div className="flex items-center gap-2 overline text-[#D8D6D0]/70 mb-2">
                      <MapPin className="w-3 h-3" /> Alberta
                    </div>
                    <div className="font-serif-display text-3xl md:text-4xl text-[#F5F3EF]">
                      {a.name}
                    </div>
                    <div className="text-xs text-[#D8D6D0]/60 mt-2">
                      {a.projects_completed}+ projects delivered
                    </div>
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-[#F5F3EF] opacity-70 group-hover:opacity-100 group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" />
                </div>
              </Link>
            </FadeUp>
          ))}
        </div>
      </section>
    </div>
  );
}
